import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import toast from '@helpers/toast';

import { searchStoneByIdApi } from './stoneLookup.api';
import { searchStoneByIdFailure, searchStoneByIdRequest, searchStoneByIdSuccess } from './stoneLookup.slice';

import { handleSagaError } from '@stone/sagaHelpers';

function* searchStoneByIdSaga(action: PayloadAction<string | number>): Generator<any, void, any> {
  try {
    const response: { item: any; steps: any[] } = yield call(searchStoneByIdApi, action.payload);
    if (response.item) {
      yield put(searchStoneByIdSuccess(response));
    } else {
      yield put(searchStoneByIdFailure('Stone not found'));
      toast.error('Stone not found');
    }
  } catch (error: any) {
    yield handleSagaError(error, searchStoneByIdFailure, 'Failed to search stone');
  }
}

export default function* stoneLookupSaga() {
  yield takeLatest(searchStoneByIdRequest.type, searchStoneByIdSaga);
}
